import { render, staticRenderFns } from "./box-5-unit-2.vue?vue&type=template&id=826878a8&scoped=true&"
import script from "./box-5-unit-2.vue?vue&type=script&lang=ts&"
export * from "./box-5-unit-2.vue?vue&type=script&lang=ts&"
import style0 from "./box-5-unit-2.vue?vue&type=style&index=0&id=826878a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "826878a8",
  null
  
)

export default component.exports